// extracted by mini-css-extract-plugin
export default {"split-pane":"SplitPane_split-pane__Veu6b"};